import React from "react";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import { TextBlock } from "../../../widget/common/ui/Text";
import SearchInput from "../../../widget/common/form/SearchInput";
import {
  CountryCodeContextImport,
  CountryCodeContextProvider,
} from "../../../provider/country_code/CountryCodeContextProvider";
import Center from "../../../widget/common/ui/Center";
import Loader from "../../../widget/common/ui/Loader";
import { Listing, ListItem } from "../../../widget/common/ui/Listing";
import { textCase } from "../../../service/ui/UI";
import UtilityHelper from "../../../service/utilities/UtilityHelper";

const CountryCodeAlert = () => {
  const type: number = ResponsiveDeviceType();

  return (
    <CountryCodeContextProvider>
      <CountryCodeAlertBody type={type} />
    </CountryCodeContextProvider>
  );
};

export default CountryCodeAlert;

const CountryCodeAlertBody = (props: { type: number }) => {
  const type: number = props.type;

  const {
    countryCodeList,
    handleOnChange,
    searchValue,
    handleOnClickCode,
    clearSearch,
  } = CountryCodeContextImport();

  return (
    <>
      {countryCodeList == null ? (
        <Center>{Loader.normal()}</Center>
      ) : (
        <>
          <SearchInput
            name="search-country-code"
            handleOnChange={handleOnChange}
            onClickSuffix={clearSearch}
            value={searchValue}
            autoFocus={true}
          />
          <Listing fixedHieght={true}>
            {(countryCodeList ?? []).map((country, key) => (
              <ListItem key={key}>
                <div
                  role="button"
                  className="d-flex align-items-center justify-content-between"
                  onClick={() => handleOnClickCode(country)}
                >
                  <TextBlock
                    maxLine={1}
                    fontName={type === 3 ? "book" : "bold"}
                    fontSize="16_17"
                    textColor="theme-label"
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: UtilityHelper.wrapKeyword(
                          country?.country_name!,
                          searchValue
                        ),
                      }}
                    />
                  </TextBlock>
                  <TextBlock
                    maxLine={1}
                    fontName="book"
                    fontSize="16_17"
                    textColor="theme-sublabel"
                  >
                    {textCase(country?.country_phonecode!)}
                  </TextBlock>
                </div>
              </ListItem>
            ))}
          </Listing>
        </>
      )}
    </>
  );
};

/* 
 return (
    <>
      {type !== 3 && (
        <Div>
          <TextBlock fontName="bold" fontSize="20_21" textColor="theme-label">
            {AppTranslation.text("country_code")}
          </TextBlock>
        </Div>
      )}
    </>
  ); */
